/**
 * 本地缓存，对齐学员 PC src/utils/storage.js
 * 默认过期时间 30 分钟
 */
export function getStorage(key: string): Record<string, any> | null {
  const item = localStorage.getItem(key)
  if (!item) {
    return null
  }
  try {
    const storageItem = JSON.parse(item)
    if (storageItem.expire_at < new Date().getTime()) {
      return null
    }
    return storageItem
  } catch (e) {
    return null
  }
}

export function setStorage(
  key: string,
  item: Record<string, any>,
  expire = 30,
): void {
  localStorage.setItem(
    key,
    JSON.stringify(
      Object.assign(item, {
        expire_at: new Date().getTime() + 1000 * 60 * expire,
      }),
    ),
  )
}

export function removeStorage(key: string): void {
  localStorage.removeItem(key)
}

export default { getStorage, setStorage, removeStorage }
